<template>
    <b-form-group id="input-group-1" label="Rut" label-for="formrow-inputState">
        <b-form-select
            id="formrow-inputState"
            :value="selectedRut"
            :options="cuentasEmpresas"
            value-field="value"
            text-field="value"
            type="text"
            disabled
        ></b-form-select>
    </b-form-group>
</template>

<script>
export default {
    beforeMount() {
        this.$emit('input', this.$store.getters["rutEmpresa/cuentaSeleccionada"].value);
        this.$emit('change', {});
    },
    methods: {
        updateValue() {
            this.$emit('change', {})
        }
    },
    computed: {
        selectedRow() {
            return this.$store.state.rutEmpresa.cuentaSeleccionada;
        },
        selectedRut() {
            return this.$store.state.rutEmpresa.cuentaSeleccionada.value;
        },
        cuentasEmpresas() {
            return this.$store.state.rutEmpresa.cuentas;
        }
    },
    watch: {
        selectedRut(newVal, oldVal) {
            // this check is mandatory to prevent endless cycle
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
                this.$emit('change', {});
            }
        }
    },
};
</script>

<style>
</style>